// Numéro de téléphone avec le chiffre à composer devant (décision William 31/10/2026) :
// 0 = METERIS (01 83 62 33 27), 1 = MCF (01 85 84 03 20), 2 = atelier (01 84 74 44 95).
// Le badge et le lien tel: portent le MÊME chiffre ; rien n'est affiché à un compte non interne.
import React from 'react';
import { LIGNES_APPEL, chiffreAjoute, phoneToDialable } from '../../lib/phone';
import { usePrefixeAppel } from '../../lib/prefixesAppel';

const COULEURS = {
  0: { fond: '#1e4264', texte: '#fff' },
  1: { fond: '#6d28d9', texte: '#fff' },
  2: { fond: '#c2410c', texte: '#fff' },
};

// `numero` : le badge ne montre que le chiffre que le lien ajoute réellement à CE numéro.
export function PrefixeAppel({ prefixe: demande, numero, style }) {
  const prefixe = chiffreAjoute(numero, demande);
  const ligne = prefixe ? LIGNES_APPEL[prefixe] : null;
  if (!ligne) return null;
  const c = COULEURS[prefixe];
  const titre = `Composer ${prefixe} avant le numéro : la personne voit le ${ligne.numero} (${ligne.nom})`;
  return (
    <span
      data-testid="prefixe-appel"
      title={titre}
      aria-label={titre}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 16, height: 16,
        padding: '0 3px', borderRadius: 4, background: c.fond, color: c.texte, fontSize: 11, fontWeight: 700,
        fontFamily: "'IBM Plex Mono', ui-monospace, monospace", lineHeight: 1, flexShrink: 0, ...style,
      }}
    >
      {prefixe}
    </span>
  );
}

/**
 * <NumeroAppel numero="06 12 34 56 78" clientId={ticket.client_id} />
 * Props : numero · clientId (société de la personne) · interne (collègue) · ligne (chiffre imposé) ·
 * lien (tel:, vrai par défaut) · style / lienStyle / title · children (texte affiché, le numéro par défaut).
 */
export default function NumeroAppel({ numero, clientId, interne, ligne, lien = true, style, lienStyle, title, children }) {
  const prefixePour = usePrefixeAppel();
  if (!numero) return null;
  const prefixe = prefixePour({ clientId, interne, ligne });
  const texte = children ?? numero;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, ...style }}>
      <PrefixeAppel prefixe={prefixe} numero={numero} />
      {lien
        ? <a href={`tel:${phoneToDialable(numero, prefixe)}`} style={lienStyle} title={title}>{texte}</a>
        : texte}
    </span>
  );
}
